<template>
    <modal ref="modal" unclosable>
        <div id="sub-wrapper">
            <img src="~@/assets/img/too_many_events.svg"/>
            <div class="title">{{ $t('modals.too_many_events.title') }}</div>
            <div class="text" v-html="$t('modals.too_many_events.text')"></div>
            <button @click="hide">{{ $t('modals.too_many_events.button') }}</button>
        </div>
    </modal>
</template>

<script>
export default {
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 35em;
}

#sub-wrapper img {
  margin-bottom: 1.5em;
  width: 12em;
}

#sub-wrapper .title {
  margin-bottom: 0.5em;
}

#sub-wrapper .text {
  margin: 0 auto 1.5em auto;
  width: 30em;
}

</style>
